export default "__VITE_ASSET__BBq0jxye__"